import React, { useState, useEffect } from "react"
import { AlertTriangle } from "lucide-react"
import { computeCohortPerformance } from "../../../utils/cohortPerformanceHelpers"

const CohortPerformanceSection = ({ orgId }) => {
  const [cohorts, setCohorts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeCohortPerformance(orgId).then((rows) => {
      setCohorts(rows)
      setLoading(false)
    })
  }, [orgId])

  if (loading) {
    return <div className="h-64 bg-muted rounded-lg animate-pulse mb-6" />
  }

  return (
    <div className="bg-card border border-border rounded-lg p-5 mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-1">Cohort Performance</h3>
      <p className="text-sm text-muted-foreground mb-5">
        See which cohorts are on track — and which need intervention.
      </p>

      {cohorts?.length === 0 ? (
        <div className="text-center py-12 text-sm text-muted-foreground bg-muted/30 rounded-lg border border-border">
          No cohorts assigned yet. Use the Cohorts panel to group enrolled learners into a cohort.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cohorts?.map((cohort) => (
            <div
              key={cohort?.cohortName}
              className={`rounded-lg border p-4 ${
                cohort?.needsAttention ? "border-warning/40 bg-warning/5" : "border-border bg-background"
              }`}
            >
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-semibold text-foreground">{cohort?.cohortName}</h4>
                {cohort?.needsAttention && <AlertTriangle size={16} className="text-warning shrink-0" />}
              </div>
              <p className="text-xs text-muted-foreground mb-3">{cohort?.learners} learners</p>
              <div className="space-y-1.5 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">Completion</span>
                  <span className={`font-semibold ${cohort?.needsAttention ? "text-warning" : "text-foreground"}`}>
                    {cohort?.completionRate}%
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">Avg. score</span>
                  <span className="font-semibold text-foreground">{cohort?.avgScore}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CohortPerformanceSection